import { Component } from '@angular/core';

@Component({
	selector: 'sb-copyright',
	standalone: true,
	imports: [],
	template: `
		<div class="text-center">&copy; {{ copyright }}</div>
	`,
})
export class CopyrightComponent {
	protected readonly copyright = `${new Date().getFullYear()} EMS LINQ, Inc. All rights reserved.`;
}
